namespace GeniuzPOS.Administration {
    export interface CsVatCodeRow {
        Id?: number;
        VatCode?: string;
        VatRate?: number;
        FullName?: string;
    }

    export namespace CsVatCodeRow {
        export const idProperty = 'VatCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Administration.CsVatCode';
        export const lookupKey = 'Administration.CsVatCode';

        export function getLookup(): Q.Lookup<CsVatCodeRow> {
            return Q.getLookup<CsVatCodeRow>('Administration.CsVatCode');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:Modify';

        export declare const enum Fields {
            Id = "Id",
            VatCode = "VatCode",
            VatRate = "VatRate",
            FullName = "FullName"
        }
    }
}
